import TelegramButton from './telegramButton.vue'
export default TelegramButton
